<template>
  <div class="error">
    <div class="error__message">Houve um erro de conexão.</div>

    <PrimaryButton @click="$emit('reconnect')">Reconectar</PrimaryButton>
  </div>
</template>

<script>
import PrimaryButton from '@/components/buttons/PrimaryButton'

export default {
  components: {
    PrimaryButton,
  }
}
</script>

<style lang="scss" scoped>
  .error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(#fff, .8);
    z-index: 3;
    gap: 8px;

    &__message {
      font-size: 15px;
      font-weight: 700;
      font-family: Poppins;
    }
  }
</style>